import { useEffect } from "react";
import { useConfig } from "@jti/ui";
import { useFreeTrial } from "../useFreeTrial";
export const NAVIGATE_AFTER_REFRESH_FLAG = "moveBackToTrialProducts";
export function useRedirectToTrialProductsFromTrialCheckout() {
    const { isFreeTrial } = useFreeTrial();
    const config = useConfig();
    const moveBackToTrialProducts = Boolean(window.localStorage.getItem(NAVIGATE_AFTER_REFRESH_FLAG));
    if (moveBackToTrialProducts) {
        window.location.replace(config.FREE_TRIAL_PAGE_URL);
        window.localStorage.removeItem(NAVIGATE_AFTER_REFRESH_FLAG);
    }
    useEffect(() => {
        const handleBeforeUnload = function () {
            if (isFreeTrial) {
                window.localStorage.setItem(NAVIGATE_AFTER_REFRESH_FLAG, "true");
            }
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [isFreeTrial]);
}
//# sourceMappingURL=useRedirectToTrialProductsFromTrialCheckout.js.map